import React from "react"; 

// core components
import GridItem from "./../../views/Grid/GridItem.js";
import GridContainer from "./../../views/Grid/GridContainer.js";
import Table from "./../../views/Table/Table.js";
import Card from "./../../views/Card/Card.js";
import CardHeader from "./../../views/Card/CardHeader.js";
import CardBody from "./../../views/Card/CardBody.js";

import axios from 'axios'
import style from './styles.module.css'
import Button from '@material-ui/core/Button' 
import IconButton from '@material-ui/core/IconButton'
import EditRoundedIcon from '@material-ui/icons/EditRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';

import Snackbar from '../utils/snackbar/Snackbar'
import {withRouter} from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import ConfPartner from "./confPartner/ConfPartner.js";
import {connect} from 'react-redux'
import TopBar from "../utils/Topbar/TopBar.js";
import {getAllPartner} from '../../containers/app/actions'
import ConfirmAlert from "../utils/ConfirmAlert/ConfirmAlert.js";

const Partner = (props) => { 
  const [data,setData] = React.useState(false)

  const [filteredData,setFilteredData] = React.useState(false)
  const [searchValue,setSearchValue] = React.useState("")
  const [selectValue,setSelectValue] = React.useState("ALL")

  const [alert,setAlert] = React.useState(false);
  const [addModal,setAddModal] = React.useState(false);
  const [editModal,setEditModal] = React.useState(false);
  const [activePartner,setActivePartner] = React.useState(false) 

  React.useEffect(() => {
    props.getAllPartner(props.user._id)
  },[]);

  React.useEffect(() => {
    setData(props.partners)
    setFilteredData(props.partners)
  },[props.partners])

  React.useEffect(() => {
    if(data) {
      let arr = [];
      arr = data.filter(val => {
        if( val.name.toLowerCase().includes(searchValue.toLowerCase()) || 
            val.location.toLowerCase().includes(searchValue.toLowerCase()) || 
            val.address.toLowerCase().includes(searchValue.toLowerCase())
          ) {
          return val;
        }
      })
      arr = arr.filter(val => {
        if(val.status == selectValue || selectValue == "ALL") {
          return val;
        }
      })
      setFilteredData(arr);
    }
  },[searchValue,selectValue])
 

  const handleDelete = (value) => {
    axios({
      method: "post",
      url: "/deletePartner",
      data: {
        partnerId: value._id,
      }
    }).then(res => {
      setAlert("Deleted Successfully")
      props.getAllPartner(props.user._id);
    }).catch(err => {
      setAlert("Something went wrong");
    })
  }

  const isLoading = !filteredData;
  const showData = !isLoading;
  const details = [];
  
  let partnerStatus = ["ALL"];
  data && data.forEach(val => partnerStatus.push(val.status));
  partnerStatus = [...new Set(partnerStatus)]

  !isLoading && filteredData.forEach((val,index) => {
    details.push(
      [
        index + 1,
        val.name,
        val.location,
        val.contactNum,
        val.address, 
        val.type,
        val.discount,
        val.status,
        <React.Fragment>  
          <IconButton onClick={() => {
            setActivePartner(val)
            setEditModal(true)
          }}>
            <EditRoundedIcon />
          </IconButton>

          <ConfirmAlert msg={`Are you sure you want delete ?`} onClickEvent={() => handleDelete(val)}>
            <IconButton>
              <DeleteRoundedIcon />
            </IconButton>
          </ConfirmAlert>
        </React.Fragment>
      ]
    )
  });


  return (
    <GridContainer>
      
      {addModal && <ConfPartner
        type="ADD" 
        open={addModal} 
        onClose={() => setAddModal(false)} 
        onDone={() => {
          setAddModal(false)
          props.getAllPartner(props.user._id)
        }}
        setAlert={(msg) => setAlert(msg)}
      />}

      {activePartner && <ConfPartner 
        type="EDIT"
        partner={activePartner} 
        open={editModal} 
        onClose={() => {
          setEditModal(false)
          setActivePartner(false)
        }} 
        onDone={() => {
          setEditModal(false)
          setActivePartner(false)
          props.getAllPartner(props.user._id)
        }} 
        setAlert={(msg) => setAlert(msg)}
      />} 

      <Snackbar open={alert} handleClose={() => setAlert(false)}/>

      <TopBar
        searchValue={searchValue} 
        onSearchChange={(value) => setSearchValue(value)} 

        select={true}
        selectValue={selectValue}
        handleSelectChange={(value) => setSelectValue(value)}
        lable="Status"
        options={partnerStatus}
        values={partnerStatus}
      />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>All Partners</h4> 
              <Button color="secondary" variant="contained" onClick={() => setAddModal(true)}>Add Partner</Button>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading &&
              <div className={style.loader}>
                <CircularProgress />
              </div>
            }
            
            {showData && 
              <Table
                tableHeaderColor="primary"
                tableHead={["Sl No", "Name", "Location", "Contact Number", "Address","Type","Discount","Status" ,"Action"]}
                tableData={details}
              />}
          </CardBody>
        </Card>
      </GridItem> 
    </GridContainer>
  );
}


const mapStateToProps = state => ({
  user: state.appReducer.user,
  partners: state.appReducer.partners
})
export default withRouter(connect(mapStateToProps,{getAllPartner})(Partner));